import { api_base_url, request } from '../utils';

const BASE = (api_base_url || '').replace(/\/+$/, '');

export class LevelService {
  static ENDPOINT = `${BASE}/level`;

  static async creates(levelCreates) {
    return await request({
      url: `${this.ENDPOINT}/`,
      method: 'POST',
      body: levelCreates
    })
  }

  static async getAll() {
    return await request({
      url: `${this.ENDPOINT}/`,
      headers: {'Accept': 'application/json'}
    })
  }

  static async updates(levelUpdates) {
    return await request({
      url: `${this.ENDPOINT}/`,
      method: 'PUT',
      body: levelUpdates
    })
  }

  static async delete(id) {
    return await request({
      url: `${this.ENDPOINT}/${encodeURIComponent(id)}`,
      method: 'DELETE',
      headers: {'Accept': 'application/json'}
    })
  }
}

export default LevelService;
